export default function WestonStickyNav() {
  const items = [
    { label: "Processing", href: "#processing" },
    { label: "Services", href: "#services" },
    { label: "Local Info", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center gap-1 overflow-x-auto py-3 scrollbar-hide">
          {items.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="flex-shrink-0 text-xs font-semibold text-gray-500 hover:text-[#1A365D] hover:bg-gray-50 px-3 py-1.5 rounded-md transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="flex-shrink-0 ml-auto bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] text-xs font-bold px-4 py-1.5 rounded-md transition-all whitespace-nowrap"
          >
            Get Started
          </a>
        </div>
      </div>
    </nav>
  );
}